const SVGComponent = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    fill="none"
  >
    <path
      d="M6.6665 8.33325L9.41058 11.0773C9.73602 11.4028 10.2637 11.4028 10.5891 11.0773L13.3332 8.33325"
      stroke="#7A7A83"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default SVGComponent
